import { Controller } from "@hotwired/stimulus"

// Vai no próprio form: data-controller="processando" e
// data-action="submit->processando#iniciar".
export default class extends Controller {
  static values = {
    titulo: { type: String, default: "Processando..." },
    mensagem: { type: String, default: "Estamos preparando o resultado." },
    // Abaixo disso (ms) a tela só trava, sem piscar o cartão numa resposta rápida.
    atraso: { type: Number, default: 140 },
  }

  connect() {
    this.encerrar = this.encerrar.bind(this)
    this.aoTerminarEnvio = this.aoTerminarEnvio.bind(this)

    // Saídas além da troca do body: erro no envio, snapshot do cache do Turbo (senão o
    // "voltar" reabre a tela travada) e bfcache do navegador.
    document.addEventListener("turbo:submit-end", this.aoTerminarEnvio)
    document.addEventListener("turbo:before-cache", this.encerrar)
    window.addEventListener("pageshow", this.encerrar)
  }

  disconnect() {
    this.encerrar()
    document.removeEventListener("turbo:submit-end", this.aoTerminarEnvio)
    document.removeEventListener("turbo:before-cache", this.encerrar)
    window.removeEventListener("pageshow", this.encerrar)
  }

  iniciar() {
    if (this.ativo) return

    this.ativo = true
    this.element.classList.add("gkg-form-travado")

    // `inert`, e não `disabled`: campo desabilitado não é enviado. Adiado um quadro
    // para não esbarrar no envio que acabou de começar.
    requestAnimationFrame(() => {
      if (this.ativo) this.element.inert = true
    })

    this.temporizador = setTimeout(() => this.#abrir(), this.atrasoValue)
  }

  encerrar() {
    if (!this.ativo) return

    this.ativo = false
    clearTimeout(this.temporizador)
    this.temporizador = null

    this.element.classList.remove("gkg-form-travado")
    this.element.inert = false

    this.overlay?.remove()
    this.overlay = null
  }

  // No sucesso o overlay fica até o Turbo trocar o body, para a tela não piscar
  // destravada entre a resposta e a renderização.
  aoTerminarEnvio(event) {
    if (!event.detail?.success) this.encerrar()
  }

  #abrir() {
    if (!this.ativo || this.overlay) return

    this.overlay = this.#montar()
    document.body.appendChild(this.overlay)
  }

  #montar() {
    const overlay = document.createElement("div")
    overlay.className = "gkg-processando"
    overlay.setAttribute("role", "alert")
    overlay.setAttribute("aria-live", "assertive")
    overlay.setAttribute("aria-busy", "true")

    overlay.innerHTML = `
      <div class="gkg-processando__cartao">
        <div class="gkg-processando__spinner" aria-hidden="true"><span></span><span></span></div>
        <p class="gkg-processando__titulo"></p>
        <p class="gkg-processando__mensagem"></p>
        <div class="gkg-processando__barra" aria-hidden="true"><span></span></div>
      </div>
    `

    overlay.querySelector(".gkg-processando__titulo").textContent = this.tituloValue
    overlay.querySelector(".gkg-processando__mensagem").textContent = this.mensagemValue

    return overlay
  }
}
